module.exports = __webpack_public_path__ + "img/474-88e824.png";